import React from "react";
import { CircularProgress } from "@material-ui/core";

const Loader = ({ style }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "absolute",
        width: "100%",
        maxWidth: "100vw",
        height: "100%",
        backgroundColor: "white",
        opacity: "0.6",
        zIndex: 10,
        ...style,
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default Loader;
